import { DefaultApiHttpClientNotificationService, NotificationsService } from "../modules/tcm-core.module";
import { TcmModalService } from "../modules/tcm-common/services/tcm-modal.service";
import { ApiHttpResponseError } from "../modules/tcm-core.module/models/http/api-http-response-error";

export class TcmApiHttpClientNotificationService extends DefaultApiHttpClientNotificationService {   
    
    constructor(protected notificationsService: NotificationsService, private modalService: TcmModalService) {        
        super(notificationsService);        
    }  

    override notifyError(error: TcmApiResponseError){
        if(error.isBusinessError){
            this.modalService.showErrorModalAsync(x => x.Messages.MessageHeadersAndActions.Error, error.message);
        }
        else{
            super.notifyError(error);
        }
    }
}

interface TcmApiResponseError extends ApiHttpResponseError {
    isBusinessError: boolean;
}